// Index file for "beta" utilities copied from the HIG.
// Will be combined into main index later.
export * from './activePage';
export * from './appInsightsHelper';
export * from './baseDefinition';
export * from './getEditUrl';
export * from './getPageFirstPlatform';
export * from './getSiteArea';
export * from './jumpToAnchor';
export * from './PlatformContext';
export * from './randomEntry';
export * from './redirects';
export * from './removeAnchorLink';
export * from './SiteDefinition.types';
export * from './string';
export * from './windowWidth';
export { getQueryParam } from '@uifabric/tsx-editor/lib/utilities/getQueryParam';
export { getSetting } from '@uifabric/tsx-editor/lib/utilities/settings';
